import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stepper, Link } from '@sentara-health/optimahealth_web';
import { HeaderLogo, ContactUsLink, HamburgerMenuLink, FooterDisclaimer } from 'organisms';
import { isAvMed } from 'context';
import LanguageDropdown from 'organisms/languageDropdown/LanguageDropdown';
import { NavigateConst } from 'common';
import { useLocation } from 'react-router-dom';
import DrRegistrationSteps from './DrRegistrationSteps';

function DrRegistrationForm() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [page, setPage] = useState(0);
  const [plantypes, setPlantypes] = useState<string>('');
  const [formData, setFormData] = useState<any>({});
  const guest = false;
  const isChildOnlyReg = pathname === NavigateConst.childOnlyPlanDesignatedRep;
  const isSentara = !isAvMed();

  const stepperLabels = useMemo(() => {
    let stepCount = 2;
    if (isChildOnlyReg) {
      stepCount = isSentara ? 4 : 3;
    }
    return Array.from({ length: stepCount }, (_, index) => `${t('common.step')} ${index + 1}`);
  }, [isChildOnlyReg, isSentara, t]);

  const stepperData = stepperLabels.map((label, index) => ({
    label,
    number: index + 1,
    testId: `stepperStep${index + 1}`,
    active: page === index,
    selected: page > index,
  }));

  return (
    <div className="d-flex flex-column h-100">
      <Link to="#main-content" className="skip-link">
        {t('common.skipToMainContent')}
      </Link>
      <header className="border-bottom">
        <div className="container-fluid">
          <nav className="header container-lg d-flex align-items-center justify-content-between">
            <HeaderLogo />
            <div className="d-flex flex-no-wrap align-items-center">
              <div className="d-none d-xl-block d-lg-block d-md-none">
                <ContactUsLink showIcon={false} />
              </div>
              {isAvMed() && (
                <div className="d-none d-xl-block d-lg-block d-md-none position-relative px-4">
                  <LanguageDropdown />
                </div>
              )}
              <div className="d-lg-none d-md-block d-sm-block">
                <HamburgerMenuLink showLogout={false} />
              </div>
            </div>
          </nav>
        </div>
      </header>

      <div className="container-fluid">
        <div id="main-content" className="container-lg px-main">
          <div className="row">
            <div className="d-flex justify-content-center align-items-center px-md-4">
              <div className="col-lg-11 col-12 py-lg-4 py-2 px-lg-5 px-sm-4 mb-lg-4 mb-2">
                <Stepper registerSteps={stepperData} />
              </div>
            </div>
            <div className="col-12 px-md-5 px-0">
              <DrRegistrationSteps
                page={page}
                setPage={setPage}
                formData={formData}
                setFormData={setFormData}
                setPlantypes={setPlantypes}
                plantypes={plantypes}
                guest={guest}
              />
            </div>
          </div>
        </div>
      </div>

      <footer className="container-lg mt-auto">
        <hr className="mt-3 mb-4 pt-2" />
        <FooterDisclaimer />
      </footer>
    </div>
  );
}

export default DrRegistrationForm;
